import ApiClient from "../helpers/ApiClient";

const baseClienteEndpoint = (cnpj) => `/empresa/${cnpj}/dashboard`;

const getTabela = () => ApiClient.backendClient.get("/api/CDashboard");

const getInadimplente = () =>
  ApiClient.backendClient.get("/Dashboard/checkInadimplente");

const getDashboard = (cnpj) =>
  ApiClient.apiClientDef.get(baseClienteEndpoint(cnpj));

const getAlertas = (cnpj, uid) =>
  ApiClient.apiClientDef.get(`${baseClienteEndpoint(cnpj)}/alertas/${uid}`);

const alterFirstLogin = (cnpj, data) =>
  ApiClient.apiClientDef.post(
    `${baseClienteEndpoint(cnpj)}/alterFirstLogin`,
    data
  );

const checkEmail = (cnpj, data) =>
  ApiClient.apiClientDef.post(`${baseClienteEndpoint(cnpj)}/checkEmail`, data);

const sendFaturamentoMessage = (cnpj, uid, data) =>
  ApiClient.apiClientDef.post(
    `/empresa/${cnpj}/faturamento/sendMsg/${uid}`,
    data
  );

const DashboardApiClient = {
  getTabela,
  getDashboard,
  getInadimplente,
  getAlertas,
  alterFirstLogin,
  checkEmail,
  sendFaturamentoMessage,
};
export default DashboardApiClient;
